import type {
  MozartComplaintReason,
  SolutionModeOption,
  TurnOffModeOption,
} from 'features/mozart-notifications/domain';

export const MOZART_COMPLAINT_REASON: Record<
  MozartComplaintReason,
  MozartComplaintReason
> = {
  DEFECT_WARNING: 'DEFECT_WARNING',
  DEFECT_GROUNDED: 'DEFECT_GROUNDED',
} as const;

export const TURN_OFF_MODE_OPTION_MAP: Record<
  TurnOffModeOption,
  TurnOffModeOption
> = {
  DAILY: 'DAILY',
  CUSTOM: 'CUSTOM',
  PERMANENT: 'PERMANENT',
} as const;

export const SOLVED_MODE_OPTION_MAP: Record<
  SolutionModeOption,
  SolutionModeOption
> = {
  cooking_adjusted: 'cooking_adjusted',
  stock_updated: 'stock_updated',
  packaging_improved: 'packaging_improved',
  other: 'other',
} as const;
